import React, { Component, Fragment } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import Currency from "../common/currency";
import auth from "../../services/authService";

class CompaniesTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      width: "2",
    },
    { path: "address", label: "Address", width: "3" },
    { path: "phone", label: "Phone", width: "2" },
    {
      path: "p_o_box",
      label: "P O Box",
      width: "1",
    },
    {
      path: "user.name",
      label: "User Name",
      width: "2",
    },
    {
      path: "user.email",
      label: "User Email",
      width: "3",
    },
    {
      path: "linked_to",
      label: "Account",
      width: "3",
      content: (company) => (company.linked_to === 1 ? "JV" : "SCRAP"),
    },
    {
      path: "status",
      label: "Status",
      width: "1",
      content: (company) =>
        company.status == 1 ? (
          <Label color="green">Active</Label>
        ) : (
          <Label color="red">InActive</Label>
        ),
    },
    {
      key: "actions",
      width: "2",
      content: (company) => (
        <div>
          {auth.getCurrentUser().email ===
            "client-unblocker@gondalgroup.ae" && (
            <React.Fragment>
              <Icon
                name={company.status == 1 ? "hide" : "eye"}
                color={company.status == 1 ? "black" : "green"}
                className="clickable"
                onClick={() => this.props.onStatusUpdate(company)}
              />
              <Icon
                name="trash"
                color="red"
                className="clickable"
                onClick={() => this.props.onDelete(company)}
              />
              <Icon
                name="user"
                color="green"
                className="clickable"
                onClick={() => this.props.onUpdateManager(company)}
              />
            </React.Fragment>
          )}
          <Icon
            name="edit"
            color="blue"
            className="clickable"
            onClick={() => this.props.onUpdate(company)}
          />
        </div>
      ),
    },
  ];

  render() {
    const { companies, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={companies}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default CompaniesTable;
